export { DispensariesEmptyStateController as DispensariesEmptyState } from './dispensaries-empty-state-controller.jsx';
